import React from 'react';

const Spinner = () => {
  return (
    <div className="history-loader">
      <img
        src="/images/spinner.gif"
        height={30}
        width={30}
      />
    </div>
  );
};

export default React.memo(Spinner);
